var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestionMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1961 7.88594L11.196 7.88593L11.1947 7.88868C11.0719 8.13668 10.8777 8.44299 10.6093 8.8087C10.272 9.26723 10.0126 9.68998 9.83315 10.0766C9.6483 10.4661 9.55877 10.9353 9.55877 11.4797V11.8011V11.9261H9.68377H10.2566H10.3693L10.3809 11.8139L10.4048 11.5825L10.4048 11.5825L10.4049 11.5814C10.4432 11.1766 10.5501 10.8259 10.7228 10.5265C10.9013 10.2172 11.1593 9.85443 11.4989 9.43752C11.8675 8.9886 12.1471 8.592 12.3352 8.24843C12.53 7.89252 12.625 7.47683 12.625 7.00561C12.625 6.37249 12.4007 5.85286 11.9498 5.45871C11.5009 5.06631 10.9207 4.875 10.2208 4.875C9.71765 4.875 9.21237 4.98165 8.70573 5.19283C8.19863 5.39562 7.76651 5.67444 7.41151 6.03022L7.34949 6.09239L7.38694 6.17182L7.7688 6.98178L7.84025 7.13334L7.96517 7.02166C8.33097 6.69465 8.70192 6.44964 9.07776 6.28436L9.07777 6.28438L9.07985 6.28343C9.45567 6.1099 9.81972 6.02495 10.173 6.02495C10.5651 6.02495 10.8583 6.12611 11.068 6.31438L11.068 6.3144L11.0699 6.31605C11.2763 6.49389 11.3845 6.74374 11.3845 7.08275C11.3845 7.3815 11.321 7.64837 11.1961 7.88594ZM9.37351 13.5636H9.24851V13.6886V15V15.125H9.37351H10.5907H10.7157V15V13.6886V13.5636H10.5907H9.37351Z",
    fill: "#8200DC",
    stroke: "#8200DC",
    strokeWidth: 0.25
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9,
    stroke: "#8200DC",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMark);
export default __webpack_public_path__ + "static/media/questionMark.1e380489a53cb88192cddf3a5e05acb8.svg";
export { ForwardRef as ReactComponent };